(function() {
"use strict";

    Backbone.FilteredCollection = Backbone.Collection.extend({
        initialize: function(data, options){
            options || (options = {});
            var display = options.display;

            this.idKey = options.id || this.idKey;

            this.cookie = options.cookie;

            this.recent = [];
            this.filtered = [];
            this.filteredRecent = [];

            this.getDisplayName = typeof display === 'function' ? 
                display : function(model) {
                    return model.get(display)
                };
        },
        reset: function(models) {
            var storedIds = $.cookie(this.cookie);
            storedIds = storedIds ?  storedIds.split(':') : [];

            Backbone.Collection.prototype.reset.apply(this,arguments);

            _.each(storedIds, function(modelId) {
                var model, query = {};

                query[this.idKey] = modelId;
                model = this.findWhere(query);
                if (model) this.recent.push(model);
            }, this);

            return this.resetFilter();
        },
        resetFilter : function() {
            this.filtered = this.models;
            this.filteredRecent = this.recent
            this.currentFilter = null;
            return this.trigger('filterReset');
        },
        filterDownTo: function(key, values) {
            this.filtered = [];
            _.isArray(values) || (values = [values]);

            _.each(values, function(value) {
                var query = {};
                query[key] = value;
                this.filtered.push.apply(this.filtered, this.where(query));
            }, this);

            this.filtered = _.unique(this.filtered);
            this.currentFilter = {key: key, values: values};

            return this
                ._filterRecentModels()
                .trigger('filterChanged');
        },
        clearSelected: function () {
            this.selected = null;

            return this.trigger('selectedCleared');
        },
        clearRecent: function() {
            this.recent = [];
            this.filteredRecent = [];
            this.cookie && $.cookie(this.cookie, '', {path: '/'});

            return this.trigger('recentCleared');
        },
        addRecent: function(model) {
            model = this._getModel(model);

            return this
                ._addRecent(model)
                ._filterRecentModels()
                ._saveRecentModels()
                .trigger('recentAdded', model);
        },
        setSelected : function(model) {
            model = this._getModel(model);
            if (this.selected === model) return this;
            this.selected = model;
            return this.trigger("selectedSet", model);
        },

        _addRecent : function(model) {
            var index = this.recent.indexOf(model);

            if (index >= 0) {
                this.recent.splice(index,1);
            }

            this.recent.unshift(model);

            if (this.recent.length > widgets.List.maxRecent) {
                this.recent.splice(this.recent.length-1, 1);
            }

            return this;
        },
        _getModel : function(id) {
            if (_.isObject(id)) return id;

            var query = {};
            query[this.idKey] = id;

            return this.findWhere(query);
        },
        _filterRecentModels: function() {
                this.filteredRecent = [];

            if (this.currentFilter) {
                _.each(this.recent, function(model) {
                    if (_.contains(this.currentFilter.values, model.attributes[this.currentFilter.key]))  {
                        this.filteredRecent.push(model)
                    }
                }, this);
            } else {
                this.filteredRecent = this.recent;
            }

            return this;
        },
        _saveRecentModels: function() {
            if (this.cookie) {
                var recentids = _.map(this.recent, function(model) {
                    return model.get(this.idKey);
                }, this);

                $.cookie(this.cookie, recentids.join(':'), {path : '/'});
            }

            return this;
        },
        idKey: 'id',
        selected : null,
        recent: null,
        filtered: null,
        filteredRecent: null,
        currentFilter: null,
        getDisplayName: function() {}
        },
        {
            maxRecent: $.cookie('list-max-recent') || 10,
            setMaxRecent : function(max) {
                this.maxRecent = max;
                $.cookie('list-max-recent', max, {path: '/'});
            }
        }
    );
}());



/*****************
 ** WEBPACK FOOTER
 ** ./js/vendor/backbone.filteredCollection.js
 ** module id = 1224
 ** module chunks = 10
 **/